import ButtonV2, { getButtonClasses } from "components/elements/buttonV2"
import PropTypes from "prop-types"
import React from "react"
import { renderClasses } from "utils/renderClasses"
import Links from "./Links"
import "./menu.scss"

const Menu = ({ callsToAction, isWholeChild, menuOpen, menus }) => (
  <div
    className={renderClasses("g-header-top-nav-menu", [[menuOpen, "--open"]])}
  >
    <div>
      <Links isWholeChild={isWholeChild} menuOpen={menuOpen} menus={menus} />
      <div className="g-header-mobile-nav-ctas-buttons ">
        {callsToAction?.href &&
          callsToAction?.map(callToAction => (
            <ButtonV2
              className={getButtonClasses(
                callToAction.buttonStyle,
                callToAction.buttonSize
              )}
              href={callToAction.href}
              key={callToAction.href}
              showArrow={callToAction?.showArrow === "Yes" ? true : false}
              text={callToAction.text}
            />
          ))}
      </div>
    </div>
  </div>
)

Menu.props = {
  ...Links.props,
}

Menu.propTypes = {
  ...Menu.props,
  menuOpen: PropTypes.bool.isRequired,
}

export default Menu
